import axios from "axios";
const endpoint = process.env.VUE_APP_BASE_API + "/api/master/customers";
const config = {
  headers: { _pub: "true" }
};

export default {
  async getAll(filter) {
    return await axios
      .get(`${endpoint}/search${filter}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getListOfPaymentMethods(customerId) {
    return await axios
      .get(`${endpoint}/${customerId}/payment-methods`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getTokenizationLink(customerId) {
    return await axios
      .get(`${endpoint}/${customerId}/tokenization-link`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getPaymentMethodById(id) {
    return await axios
      .get(`${endpoint}/payment-methods/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getAirwallexClientSecret(customerId) {
    return await axios
      .get(`${endpoint}/${customerId}/airwallex-client-secret`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getPublicAirwallexClientSecret(request) {
    return await axios
      .get(`${endpoint}/airwallex-client-secret?${request}`, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async verifyPaymentMethod(request) {
    return await axios
      .post(endpoint + "/payment-methods/verify", request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async update(request) {
    return await axios
      .put(endpoint, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async changeCardType(request) {
    return await axios
      .put(endpoint + "/payment-methods/card-type", request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async syncAuth(request) {
    return await axios
      .put(`${endpoint}/sync`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async changeStatus(request) {
    return await axios
      .put(`${endpoint}/status`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async attachPaymentMethod(request) {
    return await axios
      .put(`${endpoint}/payment-methods`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async publicAttachPaymentMethod(request) {
    return await axios
      .put(`${endpoint}/payment-methods/public-attach`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async setDefaultPaymentMethod(request) {
    return await axios
      .put(`${endpoint}/default-payment-methods`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async updatePaymentMethod(id, request) {
    return await axios
      .put(endpoint + `/payment-methods/${id}`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async delete(id) {
    return await axios
      .delete(endpoint + `/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async deletePaymentMethod(id) {
    return await axios
      .delete(endpoint + `/payment-methods/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/master/customer/customerService.js